export const ONE_LINK_TEMPLATE_URL = 'https://oblikde.onelink.me/lDmS';

export const STORAGE_KEYS = {
  clickUrl: 'af_click_url',
  shortUrl: 'af_short_url'
};

export const EVENTS = {
  clickUrl: 'oblik:clickurl',
  shortUrl: 'oblik:shorturl'
};
